<script>
  import PlatformsCheckbox from "../molecules/PlatformsCheckbox.vue";
  import UserPasswordHistories from "@/components/cards/UserPasswordHistories.vue";
  import SearchUsers from "../filter/SearchUsers.vue";
  import LocationsFilters from "../LocationsFilter/LocationsFilters.vue";
  import Modal from "@/components/modals/Modal.vue";
  import UserAllowed from "@/components/cards/UserAllowed.vue";
  import { mapGetters, mapActions, mapMutations } from "vuex";
  import OrganismUsersList from "@/components/organisms/OrganismUsersList.vue";
  import { fetchOffices } from "@/services/fetchOffices";
  import { io } from "socket.io-client";
  export default {
    props: ["users"],
    components: {
      SearchUsers,
      PlatformsCheckbox,
      LocationsFilters,
      Modal,
      UserAllowed,
      UserPasswordHistories,
      OrganismUsersList,
    },
    data() {
      return {
        title: "Cambio de contraseña",
        searchUsers: "",
        locationsSelected: [],
        citiesData: [],
        officesData: [],
        selectedUsers: [],
        showProcessingInfo: false,
        inProcess: false,
        socket: null,
        wsStatus: "idle",
        wsProgress: { percentage: 0, completed: 0, total: 0 },
        wsCaptchaModels: [],
        wsHasErrors: false,
        currentPage: 1,
        pageSize: 40,
        loadingMore: false,
        totalModels: 0,
        menu: [
          {
            id: 1,
            show: false,
            title: "Usuarios que pueden visualizar",
            interactive: false,
          },
        ],
        userPlatforms: [
          { name: "Jasmin", isSelected: false, color: "#bd0909" },
          { name: "Streamate", isSelected: false, color: "#21619a" },
        ],
        modal: null,
        captchaDetected: false,
        errorDetected: false,
        showHistory: false,
        historyData: [],
        historyLoading: false,
        historyPlatformFilter: [],
        historyPage: 0,
        historyPageSize: 10,
        historyHasMore: false,
        historyLoadingMore: false,
      };
    },
    computed: {
      ...mapGetters("competitions", ["getUsersSelectInteractive"]),
      ...mapGetters("competitions", ["getCompetition", "getUsersSelecetedView", "getInteractivePolicy", "getUsersSelectedInteractive"]),
      ...mapGetters("policies", {
        policiesDb: "policiesDb",
      }),
      ...mapGetters("user", ["getHasMoreModels"]),
      availableCities() {
        const provided = Array.isArray(this.citiesData) ? this.citiesData : [];
        if (provided.length) return provided;
        const storeCities = this.$store.getters["cities/getData"];
        const mapped = Array.isArray(storeCities) ? storeCities : [];
        return mapped.length ? mapped : null;
      },
      availableOffices() {
        const provided = Array.isArray(this.officesData) ? this.officesData : [];
        if (provided.length) return provided;
        const storeOffices = this.$store.getters["offices/getData"];
        const mapped = Array.isArray(storeOffices) ? storeOffices : [];
        return mapped.length ? mapped : null;
      },
      options() {
        const allModels = this.$store.state.user.allModels || [];
        return allModels.flatMap((area) => area.users || []);
      },
      nameIcon() {
        return function (item) {
          return item.show ? "chevronUp" : "chevronDown";
        };
      },
      isAllChecked() {
        return this.filteredUsers.every((user) => this.isCheckedUser(user));
      },
      isCheckedUser() {
        return function (userId) {
          return this.getInteractivePolicy ? this.getUsersSelectedInteractive.includes(userId) : this.getUsersSelecetedView.includes(userId);
        };
      },

      isSubmitDisabled() {
        const hasSelectedUsers = this.selectedUsers.length > 0;
        const hasSelectedPlatforms = this.userPlatforms.some((p) => p.isSelected);
        return !(hasSelectedUsers && hasSelectedPlatforms) || this.inProcess || this.showHistory;
      },
      filteredUsers() {
        const search = this.searchUsers.toLowerCase();

        let result = this.options;

        result = result.filter((user) => {
          const { user: userName, city, artisticName, office } = user;
          const includesUser = this.verifyIncludeInDate(userName, search);
          const includesCity = this.verifyIncludeInDate(city, search);
          const includesArtisticName = this.verifyIncludeInDate(artisticName, search);
          const includesOffice = this.verifyIncludeInDate(office, search);

          return includesUser || includesCity || includesArtisticName || includesOffice;
        });

        return result;
      },
      hasMorePages() {
        return this.getHasMoreModels;
      },
      filteredHistoryData() {
        return this.historyData;
      },
      activePlatformParam() {
        if (this.historyPlatformFilter.length === 1) return this.historyPlatformFilter[0];
        return null;
      },
      hasCaptchaError() {
        return this.captchaDetected || this.wsCaptchaModels.length > 0;
      },
      hasAnyError() {
        return this.wsHasErrors || this.wsStatus === "failed" || this.errorDetected;
      },
    },
    watch: {
      "$store.state.user.toShowChangePassword"(newVal) {
        if (newVal === 1) {
          this.syncProcessState();
          requestAnimationFrame(() => {
            this.$nextTick(() => {
              setTimeout(() => {
                this.focusModal();
              }, 150);
            });
          });
        }
      },
      searchUsers() {
        this.currentPage = 1;
        this.fetchModelsWithSearch();
      },
    },
    methods: {
      ...mapMutations("competitions", ["setInteractivePolicy", "setUsersSelectedInteractive"]),
      ...mapActions("policies", { getPolicies: "getPolicies" }),
      ...mapActions("user", ["getAllModels"]),
      emitSearch(event) {
        this.searchUsers = event.target.value;
      },
      async fetchModelsWithSearch() {
        this.loadingMore = false;
        await this.getAllModels({
          search: this.searchUsers,
          page: this.currentPage,
          pageSize: this.pageSize,
          locations: this.locationsSelected,
        });
      },
      async handleLoadMore() {
        this.loadingMore = true;
        this.currentPage += 1;
        await this.getAllModels({
          search: this.searchUsers,
          page: this.currentPage,
          pageSize: this.pageSize,
        });
        this.loadingMore = false;
      },
      handleSelectAll(event) {
        const isChecked = event.target.checked;
        if (isChecked) {
          this.selectedUsers = [...this.filteredUsers];
        } else {
          this.selectedUsers = [];
        }
      },
      handleSelectUser({ user, event }) {
        const isChecked = event.target.checked;
        if (isChecked) {
          if (!this.selectedUsers.some((u) => u._id === user._id)) {
            this.selectedUsers.push(user);
          }
        } else {
          this.selectedUsers = this.selectedUsers.filter((u) => u._id !== user._id);
        }
      },
      updatePlatform({ name, checked }) {
        const platform = this.userPlatforms.find((p) => p.name === name);
        if (platform) platform.isSelected = checked;
      },
      handleLocationChange(locations) {
        this.locationsSelected = locations;
        this.currentPage = 1;
        this.selectedUsers = [];
        this.fetchModelsWithSearch();
      },
      syncProcessState() {
        const inProcess = this.$store.state.user.passwordChangeInProcess;
        const captchaData = this.$store.state.user.passwordChangeCaptchaData;

        if (inProcess) {
          this.inProcess = true;
          this.showProcessingInfo = true;
          const savedProgress = this.$store.state.user.passwordChangeProgress;
          if (savedProgress && savedProgress.total > 0) {
            this.wsProgress = { ...savedProgress };
          }
          if (!this.socket) this.connectSocket();
        }

        this.errorDetected = !!this.$store.state.user.passwordChangeErrorDetected;

        if (captchaData && captchaData.detected === true) {
          this.captchaDetected = true;
          this.wsCaptchaModels = Array.isArray(captchaData.users) && captchaData.users.length ? captchaData.users : [{}];
          this.wsStatus = "failed";
          this.showProcessingInfo = true;
        } else {
          this.captchaDetected = false;
        }
      },
      close() {
        this.disconnectSocket();
        this.showHistory = false;
        this.$store.state.user.toShowChangePassword = 0;
        this.$store.dispatch("user/changeRoleInDataUser", "model");
      },
      async fetchHistory() {
        this.historyLoading = true;
        this.historyData = [];
        this.historyPage = 0;
        this.historyHasMore = false;
        try {
          const res = await this.$store.dispatch("platforms/getCompletedPasswordChanges", {
            page: 0,
            pageSize: this.historyPageSize,
            platform: this.activePlatformParam,
          });
          const data = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
          this.historyData = data;
          this.historyHasMore = res?.hasMore ?? data.length >= this.historyPageSize;
        } catch {
          this.historyData = [];
        } finally {
          this.historyLoading = false;
        }
      },
      async openHistory() {
        this.showHistory = true;
        await this.fetchHistory();
      },
      async loadMoreHistory() {
        if (this.historyLoadingMore || !this.historyHasMore) return;
        this.historyLoadingMore = true;
        this.historyPage += 1;
        try {
          const res = await this.$store.dispatch("platforms/getCompletedPasswordChanges", {
            page: this.historyPage,
            pageSize: this.historyPageSize,
            platform: this.activePlatformParam,
          });
          const data = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
          this.historyData.push(...data);
          this.historyHasMore = res?.hasMore ?? data.length >= this.historyPageSize;
        } catch {
          this.historyHasMore = false;
        } finally {
          this.historyLoadingMore = false;
        }
      },
      closeHistory() {
        this.showHistory = false;
        this.historyData = [];
        this.historyPage = 0;
        this.historyHasMore = false;
        this.historyPlatformFilter = [];
      },
      async toggleHistoryFilter(platform) {
        const idx = this.historyPlatformFilter.indexOf(platform);
        if (idx === -1) {
          this.historyPlatformFilter.push(platform);
        } else {
          this.historyPlatformFilter.splice(idx, 1);
        }
        await this.fetchHistory();
      },
      changeMenu(item) {
        this.menu = this.menu.map((ele) => ({
          ...ele,
          show: ele.id === item.id ? !ele.show : false,
        }));
      },

      verifyIncludeInDate(dateIn, compare) {
        const formattedDate = this.cleanString(dateIn || "");
        const formattedCompare = this.cleanString(compare);
        return formattedDate.includes(formattedCompare);
      },

      cleanString(str) {
        return str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();
      },
      isCheckedUserClass(userId) {
        return this.getInteractivePolicy ? this.getUsersSelectedInteractive.some((user) => user._id === userId) : this.getUsersSelecetedView.some((ele) => ele._id === userId);
      },
      nameUser({ artisticName, user }) {
        return artisticName || user;
      },

      nameUser({ artisticName, user }) {
        return artisticName || user;
      },

      nameArea({ area }) {
        return area?.name;
      },
      async deleteUser(user) {
        this.selectedUsers = this.selectedUsers.filter((u) => u._id !== user._id);
        this.$toast.success("Actualizado");
      },
      async handleSubmit() {
        this.wsStatus = "idle";
        this.wsProgress = { percentage: 0, completed: 0, total: this.selectedUsers.length };
        this.wsCaptchaModels = [];
        this.wsHasErrors = false;
        this.showProcessingInfo = true;
        const selectedPlatforms = this.userPlatforms.filter((p) => p.isSelected);
        const userIds = this.selectedUsers.map((u) => u._id);
        const locationIds = this.locationsSelected.map((loc) => loc._id);

        let platform = "";
        if (selectedPlatforms.length === 1) {
          platform = selectedPlatforms[0].name === "Jasmin" ? "jasmin" : "streamate";
        } else if (selectedPlatforms.length === 2) {
          platform = "dual";
        }

        const changePasswordData = {
          userId: this.$userData._id,
          platform,
          ids: userIds,
          locations: locationIds,
        };

        try {
          this.connectSocket();
          const response = await this.$store.dispatch("platforms/executeChangePassword", changePasswordData);
          const responseData = response?.data || response;

          if (responseData?.inProcess) {
            this.inProcess = true;
            if (responseData?.message) {
              this.$toast.warning(responseData.message);
            }
          }
        } catch (error) {
          console.error(error);
          this.showProcessingInfo = false;
          this.disconnectSocket();
        }
      },
      connectSocket() {
        const socketUrl = process.env.VUE_APP_CHANGE_PASSWORD_SOCKET;
        this.socket = io(socketUrl, { transports: ["websocket"] });

        this.socket.on("connect", () => console.log("[Socket] conectado:", this.socket.id));
        this.socket.onAny((event, ...args) => console.log("[Socket] evento:", event, args));

        this.socket.on("passwordChange:start", () => {
          this.wsStatus = "running";
        });

        this.socket.on("passwordChange:progress", (data) => {
          if (data.status === "failed") {
            this.wsHasErrors = true;
            return;
          }
          if (data.status !== "processed") return;
          this.wsProgress = {
            percentage: data.percentage ?? this.wsProgress.percentage,
            completed: data.completed ?? this.wsProgress.completed,
            total: data.total ?? this.wsProgress.total,
          };
        });

        this.socket.on("passwordChange:completed", () => {
          this.wsStatus = "completed";
          this.inProcess = false;
          this.selectedUsers = [];
          this.userPlatforms = this.userPlatforms.map((p) => ({ ...p, isSelected: false }));
          this.disconnectSocket();
        });

        this.socket.on("passwordChange:captcha", (data) => {
          this.wsCaptchaModels.push(data);
        });

        this.socket.on("passwordChange:failed", () => {
          this.wsStatus = "failed";
          this.inProcess = false;
          this.disconnectSocket();
        });
      },

      disconnectSocket() {
        if (!this.socket) return;
        this.socket.disconnect();
        this.socket = null;
      },

      async initLocationsData() {
        try {
          const offices = await fetchOffices();
          const storeCities = this.$store.getters["cities/getData"];
          this.citiesData = Array.isArray(storeCities) ? storeCities.filter((c) => c.isEnable) : [];
          this.officesData = Array.isArray(offices) ? offices : [];
        } catch (error) {
          console.error("Error loading locations:", error);
          this.citiesData = [];
          this.officesData = [];
        }
      },
      focusModal() {
        try {
          const modalElement = this.$refs.modal?.$el;
          if (!modalElement) return;

          const modalContainer = modalElement.querySelector(".modal-g__container");

          if (modalContainer) {
            if (!modalContainer.hasAttribute("tabindex")) {
              modalContainer.setAttribute("tabindex", "-1");
            }
            modalContainer.focus();
            this.announceToScreenReader("Modal de cambio de contraseña abierto. Presione Tab para navegar.");
            return;
          }

          const firstInteractiveElement = modalElement.querySelector(
            'input:not([type="hidden"]), button:not([aria-hidden="true"]), select, textarea, [role="button"], [role="checkbox"], [role="radio"]',
          );

          if (firstInteractiveElement) {
            firstInteractiveElement.focus();
            this.announceToScreenReader("Modal de cambio de contraseña abierto. Presione Tab para navegar.");
          }
        } catch (error) {
          console.warn("Error al enfocar el modal:", error);
        }
      },
      announceToScreenReader(message) {
        const announcement = document.createElement("div");
        announcement.setAttribute("role", "status");
        announcement.setAttribute("aria-live", "polite");
        announcement.setAttribute("aria-atomic", "true");
        announcement.className = "sr-announcement";
        announcement.textContent = message;
        document.body.appendChild(announcement);

        setTimeout(() => {
          announcement.remove();
        }, 2000);
      },
    },
    beforeDestroy() {
      this.disconnectSocket();
    },
    async mounted() {
      this.syncProcessState();

      await this.initLocationsData();
      if (this.$user.role === "superadmin") {
        await this.fetchModelsWithSearch();
      }
      await this.getPolicies();
      await this.changeMenu(this.menu[0]);

      if (this.$store.state.user.toShowChangePassword === 1) {
        requestAnimationFrame(() => {
          this.$nextTick(() => {
            setTimeout(() => {
              this.focusModal();
            }, 150);
          });
        });
      }
    },
  };
</script>

<template>
  <Modal
    class="modalChangePassword"
    :class="{ 'modalChangePassword--historyView': showHistory }"
    :showMask="true"
    :isDisableSubmit="isSubmitDisabled"
    submitText="Actualizar"
    @onCancel="close"
    @onSubmit="handleSubmit"
    ref="modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="modalChangePasswordTitle"
    tabindex="-1">
    <template v-slot:footer>
      <div class="modal-g__buttons" v-if="!showHistory">
        <button class="modal-g__button cancel" @click="close">Cancelar</button>
        <button class="modal-g__button submit" @click="handleSubmit" :disabled="isSubmitDisabled">Actualizar</button>
      </div>
    </template>
    <template v-slot:header>
      <div class="modalChangePassword__header" role="banner">
        <h1 class="modalChangePassword__title" id="modalChangePasswordTitle">{{ title }}</h1>
        <button class="modalChangePassword__close" @click="close" aria-label="Cerrar diálogo de cambio de contraseña">
          <iconic class="modalChangePassword__icon" name="close" aria-hidden="true" />
        </button>
      </div>
    </template>
    <template v-slot:body>
      <section v-if="showHistory" class="changePasswordHistory" aria-label="Historial de cambio de contraseñas">
        <div class="changePasswordHistory__header">
          <h2 class="changePasswordHistory__title">Historial de cambio de contraseñas</h2>
          <button class="changePasswordHistory__back" @click="closeHistory" type="button" aria-label="Volver al formulario">
            <iconic name="chevronLeft" aria-hidden="true" />
            <span>volver</span>
          </button>
        </div>
        <div class="changePasswordHistory__filters" role="group" aria-label="Filtrar por plataforma">
          <button
            type="button"
            class="changePasswordHistory__filterBtn"
            :class="{ 'changePasswordHistory__filterBtn--activeJasmin': historyPlatformFilter.includes('jasmin') }"
            @click="toggleHistoryFilter('jasmin')">
            Jasmin
            <iconic v-if="historyPlatformFilter.includes('jasmin')" name="xIcon" class="changePasswordHistory__filterClose changePasswordHistory__filterClose--jasmin" aria-hidden="true" />
          </button>
          <button
            type="button"
            class="changePasswordHistory__filterBtn"
            :class="{ 'changePasswordHistory__filterBtn--activeStreamate': historyPlatformFilter.includes('streamate') }"
            @click="toggleHistoryFilter('streamate')">
            Streamate
            <iconic v-if="historyPlatformFilter.includes('streamate')" name="xIcon" class="changePasswordHistory__filterClose changePasswordHistory__filterClose--streamate" aria-hidden="true" />
          </button>
        </div>
        <div v-if="historyLoading" class="changePasswordHistory__loading" role="status">
          <span>Cargando historial...</span>
        </div>
        <div v-else-if="!historyData.length" class="changePasswordHistory__empty">
          <p>No hay registros de cambios de contraseña.</p>
        </div>
        <UserPasswordHistories v-else :users="filteredHistoryData" />
        <div v-if="historyHasMore" class="changePasswordHistory__loadMore">
          <button @click="loadMoreHistory" :disabled="historyLoadingMore" type="button" class="changePasswordHistory__loadMoreBtn">
            {{ historyLoadingMore ? "Cargando..." : "Cargar más" }}
          </button>
        </div>
      </section>

      <template v-if="!showHistory">
        <section class="changePassword" aria-label="Filtros y búsqueda de usuarios">
          <div class="changePassword__subHeader">
            <div>
              <p id="instructions">Selecciona las modelos a las que desea cambiar contraseña.</p>
            </div>
            <button class="changePassword__buttonHistory" @click="openHistory" role="button" aria-label="Ver historial de cambios" style="cursor: pointer"><iconic name="historyIcon" /></button>
          </div>
          <div class="changePassword__viewFilters" role="search" aria-labelledby="instructions">
            <label for="search-users" class="sr-only">Buscar usuario por nombre, ciudad u oficina</label>
            <SearchUsers id="search-users" placeholder="Buscar usuario" icon="my_search" @onChange="emitSearch" />
            <LocationsFilters
              id="filter-cities"
              icon="filter"
              placeholder="Ciudades y Oficinas"
              :locationsSelected="locationsSelected"
              :onUpdLocations="handleLocationChange"
              :cities="availableCities"
              :offices="availableOffices" />
          </div>
        </section>
        <section class="usersChangePassword" aria-label="Selección de usuarios y plataformas">
          <template v-if="filteredUsers.length">
            <div role="region" aria-label="Lista de modelos disponibles">
              <h2 id="usersChangePassword__heading" class="usersChangePassword__heading">Modelos</h2>
              <OrganismUsersList
                :users="filteredUsers"
                :selectedUsers="selectedUsers"
                @isChecked="handleSelectAll"
                @isCheckedAction="handleSelectUser"
                @handleClickMorebutton="handleLoadMore"
                :showMoreButton="hasMorePages"
                :loadingMore="loadingMore"
                aria-labelledby="usersChangePassword__heading" />
            </div>
            <div role="region" aria-label="Selección de plataformas y usuarios seleccionados">
              <h2 id="usersChangePassword-heading" class="usersChangePassword__heading">Selección de plataformas</h2>
              <PlatformsCheckbox :platforms="userPlatforms" @update-platform="updatePlatform" aria-labelledby="platforms-heading" />
              <UserAllowed :users="selectedUsers" :nameUser="nameUser" :nameArea="nameArea" :deleteUser="deleteUser" :aria-label="`${selectedUsers.length} usuario(s) seleccionado(s)`" />
            </div>
          </template>
        </section>
        <div
          v-if="showProcessingInfo"
          class="modalChangePassword__info"
          :class="[`modalChangePassword__info--${wsStatus}`, { 'modalChangePassword__info--hasError': hasCaptchaError || hasAnyError }]"
          role="status"
          aria-live="polite"
          aria-atomic="true"
        >
          <div>
            <p>
              <span class="modalChangePassword__clockWrapper">
                <iconic class="modalChangePassword__clock" name="clock" />
              </span>
              <strong v-if="wsStatus !== 'completed' && wsStatus !== 'failed'" class="modalChangePassword__statusCompleted">Procesando cambio de contraseñas...</strong>
              <strong v-else-if="wsStatus === 'completed'" class="modalChangePassword__statusCompleted">Proceso finalizado.</strong>
              <strong v-else>El proceso falló. Intente de nuevo.</strong>
            </p>
          </div>
          <div class="modalChangePassword__progress-wrap">
            <div class="modalChangePassword__progress-track" role="progressbar" :aria-valuenow="wsProgress.percentage" aria-valuemin="0" aria-valuemax="100">
              <div class="modalChangePassword__progress-bar" :style="{ width: wsProgress.percentage + '%' }" />
            </div>
            <p class="modalChangePassword__progress-label">{{ wsProgress.completed }} / {{ wsProgress.total }} ({{ wsProgress.percentage }}%)</p>
          </div>
          <div>
            <p v-if="wsStatus !== 'completed'">Durante este proceso, no se podrán enviar nuevas solicitudes.</p>
            <p v-if="hasCaptchaError" class="modalChangePassword__captcha-title">
              <iconic class="modalChangePassword__alert" name="alert" /> Se detectó un captcha durante el proceso. Por favor comunícate con desarrollo.
            </p>
            <p v-if="hasAnyError && !hasCaptchaError" class="modalChangePassword__error-notice">
              <iconic class="modalChangePassword__alert" name="alert" />Se ha generado un error en el cambio de contraseña.
            </p>
          </div>
        </div>
      </template>
    </template>
  </Modal>
</template>

<style lang="scss">
  .changePasswordHistory {
    width: 95%;
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 0 4px 20px;

    &__header {
      display: flex;
      align-items: center;
      gap: 10px;
      justify-content: space-between;
    }

    &__back {
      display: flex;
      height: 35px;
      padding: 10px;
      justify-content: center;
      align-items: center;
      gap: 4px;
      border-radius: 8px;
      background: #e9e9e9;
      border: none;
      line-height: 1px;
    }

    &__title {
      font-size: 16px;
      font-weight: 500;
      color: #000;
      line-height: normal;
      font-style: normal;
      font-family: $newFont_semiBold;
      text-transform: none;
    }

    &__filters {
      display: flex;
      gap: 8px;
      padding: 4px 0 8px;
    }

    &__filterBtn {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 5px 12px;
      border-radius: 20px;
      border: 1px solid #e0e0e0;
      background: #fff;
      color: #555;
      font-size: 13px;
      cursor: pointer;
      transition: all 0.2s ease;
      &:hover {
        border-color: #bdbdbd;
        background: #f5f5f5;
      }
      &--activeJasmin {
        background: rgba(189, 9, 9, 0.15);
        border-color: transparent;
        box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.27);
        color: #bd0909;
      }
      &--activeStreamate {
        background: rgba(33, 97, 154, 0.15);
        border-color: transparent;
        box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.27);
        color: #21619a;
      }
    }
    &__filterClose {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 10px !important;
      height: 10px !important;
      line-height: 1;
      svg {
        width: 10px !important;
        height: 10px !important;
        display: block;
      }
      &--jasmin svg path {
        fill: #bd0909;
      }
      &--streamate svg path {
        fill: #21619a;
      }
    }

    &__loading,
    &__empty {
      padding: 24px;
      text-align: center;
      color: #888;
      font-size: 14px;
      min-height: 450px;
    }

    &__loadMore {
      display: flex;
      padding: 12px 0 4px;
    }

    &__loadMoreBtn {
      background: none;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      padding: 6px 16px;
      font-size: 13px;
      color: #555;
      cursor: pointer;
      transition: background 0.2s;
      &:hover:not(:disabled) {
        background: #f5f5f5;
      }
      &:disabled {
        opacity: 0.6;
        cursor: default;
      }
    }
  }

  .Vue-Toastification {
    &__toast--success {
      background: #fff;
      color: #4caf50;
    }

    &__close-button {
      font-weight: bold;
      font-size: 24px;
      line-height: 24px;
      background: transparent;
      outline: none;
      border: none;
      padding: 0;
      padding-left: 10px;
      cursor: pointer;
      transition: 0.3s ease;
      align-items: center;
      color: #000000;
      opacity: 0.3;
      transition: visibility 0s;
    }
  }

  .usersChangePassword {
    width: 95%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;

    &__heading {
      color: #000;
      font-family: $newFont_regular;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-transform: none;
      padding-bottom: 9px;
    }
  }

  .modalChangePassword--historyView {
    .modal-g__buttons {
      display: none !important;
    }
  }

  .modalChangePassword {
    font-family: "InterDisplay-Regular";
    .modal-g__container {
      width: 100%;
      max-width: 900px;
      padding: 0;
      gap: $mpadding;
      max-height: 100vh;
      outline: none;
      &:focus {
        outline: 2px solid $primary-color;
        outline-offset: 2px;
      }
    }
    .modal-g__buttons {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    .modal-g__button {
      border-radius: 10px;
      padding: 7.5px 12px;
      &.cancel {
        background-color: #fff;
        color: #db0909;
      }
    }

    &__alert {
      color: #bd0909;
      font-size: 14px;
    }

    &__header {
      @include Flex(row, space-between);
      width: 100%;
      padding: $mpadding;
    }
    &__title {
      color: #bd0909;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      font-family: $newFont_semiBold;
      text-transform: none;
    }
    &__close {
      @include Flex(row);
      height: 35px;
      width: 35px;
      color: $primary-color;
      border: none;
      border-radius: 50%;
      background: none;
      cursor: pointer;
      transition: 0.3s ease-in-out;
      &:hover {
        background: #bd09092e;
      }
    }
    &__icon {
      &--aprove {
        color: #209e0c;
      }
      &--closeBold {
        color: $primary-color;
      }
    }
    &__clockWrapper {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 19px;
      height: 19px;
      flex-shrink: 0;
    }
    &__clock {
      color: #3d3d3d;
      width: 100% !important;
      height: 100% !important;
      svg {
        width: 100% !important;
        height: 100% !important;
      }
    }
    &__info {
      margin: 0px 20px;
      padding: 12px 14px;
      background-color: #e2ffdf;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      gap: 10px;

      &--hasError {
        background-color: #bd090910;

        .modalChangePassword__progress-track {
          background-color: #dddddd;
        }

        .modalChangePassword__progress-bar {
          background-color: #818181;
        }
      }
      width: 95%;
      font-size: 13px;
      :first-child {
        align-items: center;
        display: flex;
        gap: 5px;
      }

      > div:first-child p {
        font-weight: bold;
        font-size: 15px;
      }
    }

    &__captcha {
      background-color: rgba(189, 9, 9, 0.04);
      border: 1px solid rgba(189, 9, 9, 0.3);
      border-radius: 8px;
      padding: 12px 14px;
      display: flex;
      flex-direction: column;
      width: 95%;
      margin: 0px 20px;

      &-title {
        display: flex;
        align-items: center;
        gap: 4px;
        color: #3d3d3d;
        font-size: 15px;
      }

      &-msg {
        font-size: 13px;
        color: #333;
      }

      &-list {
        margin: 6px 0 0;
        padding: 0;
        list-style: none;
        display: flex;
        flex-direction: column;
        gap: 6px;
      }

      &-item {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
        padding: 6px 8px;
        background: rgba(189, 9, 9, 0.06);
        border-radius: 6px;
        font-size: 12px;
      }

      &-user {
        font-weight: 600;
        color: #bd0909;
      }

      &-platform {
        background: rgba(189, 9, 9, 0.12);
        color: #bd0909;
        padding: 1px 8px;
        border-radius: 10px;
        font-size: 11px;
      }

      &-error {
        color: #555;
        font-size: 11px;
        flex-basis: 100%;
      }
    }

    &__error-notice {
      display: flex;
      align-items: center;
      gap: 4px;
      color: #3d3d3d;
      font-size: 15px;
      margin: 4px 0 0;
    }

    &__statusCompleted {
      color: #3d3d3d;
    }

    &__progress-wrap {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    &__progress-track {
      width: 100%;
      height: 5px;
      background-color: #c8f0c4;
      border-radius: 5px;
      overflow: hidden;
    }

    &__progress-bar {
      height: 100%;
      background-color: #4caf50;
      border-radius: 5px;
      transition: width 0.3s ease;
    }

    &__progress-label {
      font-size: 0.85rem;
      color: #444;
      margin: 0;
    }

    .changePassword {
      width: 95%;
      &__viewFilters {
        display: flex;
        align-items: center;
        gap: 10px;
        margin: 13px 0;
        margin-bottom: 5px;
        padding: 0 0.5rem;
      }
      &__buttonHistory {
        display: flex;
        align-items: center;
        gap: 10px;
        background: none;
        border: none;
        cursor: pointer;
        font-size: 20px;
        padding: 8px;
        border-radius: 8px;
        transition: background 0.2s;
        &:hover {
          background: #d8d8d8;
        }
      }
      .locationsList {
        background: #fff;
        border-radius: 22px;
        box-shadow: unset;
        border: 1px solid rgba(92, 89, 89, 0.25);
      }
      &__viewSections {
        height: 490px;
      }
      &__subHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .sr-announcement {
    position: absolute;
    left: -10000px;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }
</style>
